import { useCallback, useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { authApi } from "../../api/auth";
import { DEFAULT_BRANDING } from "../../shared/branding";
import { AuthShell } from "../../shared/AuthShell";
import { errorMessage } from "../../shared/errors";
import { Turnstile } from "../../shared/Turnstile";
import { Alert, Button, Input } from "../../ui";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [captcha, setCaptcha] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const onToken = useCallback((token: string | null) => setCaptcha(token), []);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await authApi.requestReset({
        email,
        turnstile_token: captcha ?? undefined,
      });
      setDone(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell branding={DEFAULT_BRANDING} title="Reset your password">
      {done ? (
        <Alert kind="success">
          If an account exists for {email}, a reset link is on its way.
        </Alert>
      ) : (
        <form
          onSubmit={submit}
          className="flex flex-col gap-4"
          aria-label="Request password reset"
        >
          {error ? <Alert kind="error">{error}</Alert> : null}
          <Input
            label="Email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Turnstile onToken={onToken} />
          <Button type="submit" loading={busy}>
            Send reset link
          </Button>
          <Link className="text-sm text-brand underline" to="/login">
            Back to sign in
          </Link>
        </form>
      )}
    </AuthShell>
  );
}
